import { styled } from '../stitches.config';

export const visuallyHiddenCSS = {
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: 1,
};

export const VisuallyHidden = styled('div', visuallyHiddenCSS);
